module.exports = __webpack_public_path__ + "media/images/gallery/gal_tab_on-3cbf3856c043ebcae68bb4a3249bdde2.jpg";